export const TEST_ID = 'serviceIntervalConfigRows';
